import { render, staticRenderFns } from "./SettingsNotification.vue?vue&type=template&id=66678452&"
import script from "./SettingsNotification.vue?vue&type=script&lang=js&"
export * from "./SettingsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports